import CourseResourceEditViewModel from '../../resource/editor/editor-vm';
export default function (data, parent) {
  var self = new CourseResourceEditViewModel(data);
  var r = Kadenze.Util.objFromString;
  var $container = parent.$resourceContainer;

  self.domId(self.resource() ? ('resource-' + self.resource().id()) : self.domId()); //To play nice with sortable
  self.resource_type_name = ko.computed(function() {
    var type = (self.resource_type && self.resource_type()) ? self.resource_type().replace('Resource', '') : '';
    return Kadenze.I18n.t('resource.type.' + type.charAt(0).toLowerCase() + type.slice(1));
  });
  self.editing = ko.observable(r(data, 'editing', false));
  self._destroy = ko.computed({
    read: function() {
      return self.resource()._destroy();
    },
    write: function(value) {
      self.resource()._destroy(value);
    }
  });

  self.keysToWatch = ['title', 'description', 'type'];
  self.snapshot = {};

  self.takeSnapshot = function() {
    //TODO: Fix info snap-shooting
    _.each(self.keysToWatch, function(key) { self.snapshot[key] = _.isObject(self.resource()[key]()) ? self.resource()[key]().toString() : self.resource()[key](); });
  };

  self.restoreSnapshot = function() {
    _.each(self.keysToWatch, function(key) {
      if (_.has(self.snapshot, key))
        self.resource()[key](self.snapshot[key]);
    });
  };

  self.resetSnapshot = function() {
    self.snapshot = {};
  };

  self.validate = function() {
    var propsToValidate = [];
    _.each(Object.getOwnPropertyNames(self.resource()), function(key) {
      if (ko.isObservable(self.resource()[key])) {
        propsToValidate.push(self.resource()[key]);
      }
    });
    propsToValidate.push(self.resource_type);
    var errors = ko.validation.group(propsToValidate);
    errors.showAllMessages(true);
    return errors();
  };

  self.isValid = function () {
    return self.validate().length == 0;
  };

  self.toggleEditor = function() {
    if (!self.editing()) {
      self.takeSnapshot();
    }
    var $row = $('#' + self.domId());
    var $editRow = $('.display-table__edit_row', $row);
    $row.toggleClass('collapsed');
    $row.toggleClass('expanded');
    $editRow.collapse('toggle');
    self.editing(!self.editing());
  };

  self.destroy = (_item, event) => {
    Kadenze.UIUtil.confirmAction('Are you sure you want to delete this resource?', () => {
      const resourceToRemove = parent.coursework().resources().filter(
          r => r.id != self.resource().id()
        )[0]

      resourceToRemove._destroy(true)

      parent.save($container)
    })

    event.stopPropagation()
  }

  self.add = function(item, event) {
    if(item.multiResourceSelectionEnabled()) {
      // User is attaching existing resources
      self.attachExistingResource();
    } else {
      // User has created a new resource
      self.addNewResource(item);
    }
  };

  self.attachExistingResource = function() {
    // Need to save without pushing a new item into the resources array
    // if we are attaching an existing resource
    var response = parent.save($container);

    response.success(function() {
      parent.newResource(false);
    });
  };

  // Add a brand new resource
  self.addNewResource = function(item) {
    if (item.isValid()) {
      item.resource().status(parent.coursework().status());
      parent.coursework().resources.push(item);

      var response = parent.save($container);

      response.success(function() {
        parent.newResource(false);
      });

      response.error(function (xhr, textStatus, errorThrown) {
        parent.coursework().resources.pop();
        new Kadenze.Notice.error($.extend({}, parent.defaultNoticeOptions, { message: xhr.responseJSON.errors }));
      });
    }
  };

  self.update = function(item, event) {
    if (self.isValid()) {
      var response = parent.save($container);
      response.success(function() {
        self.resetSnapshot();
      });
      response.error(function (xhr, textStatus, errorThrown) {
        new Kadenze.Notice.error($.extend({}, parent.defaultNoticeOptions, { message: xhr.responseJSON.errors }));
      });
    }
  };

  self.cancel = function(item, event) {
    if (parent.newResource()) {
      parent.newResource(false);
    } else {
      self.restoreSnapshot();
      self.toggleEditor();
    }
  };

  return self;
}


